import AdminDashboard from "../../components/SuperAdmin/Dashboard";
import Details from "../../components/SuperAdmin/Details";

// Tenant
import AddTenant from "../../components/SuperAdmin/AddTenant";
import Tenant from "../../components/SuperAdmin/Tenant";

// Settings
import OktaSetup from "../../components/SuperAdmin/settings/OktaSetup";
import Settings from "../../components/SuperAdmin/settings/Settings";
// WorkloadIdentity
import WorkloadIdentity from "../../components/workloadIdentity/workloadIdentity";
import WorkloadConditionalAccess from "../../components/workloadIdentity/WorkloadConditionalaccess";
import AddWorkloadIdentity from "../../components/workloadIdentity/AddworkloadIdentity";
import ServiceAccount from "../../components/serviceAccount/ServiceAccount";
import AddServiceAccount from "../../components/serviceAccount/AddServiceAccount";

const orgRouter = [
  {
    path: "dashboard/*",
    children: [
      { path: "", element: <AdminDashboard /> },
      { path: "details", element: <Details /> },
    ],
  },
  
];


const tenantRouter = [
    { path: "", element: <Tenant /> },
    { path: "add", element: <AddTenant /> }
];


const settingsRouter = [
    { path: "", element: <Settings /> },
    { path: "okta", element: <OktaSetup /> },
];

const workloadIdentityRouter = [
  { path: "", element: <WorkloadIdentity /> },
  { path: "addWorkloadIdentity", element: <AddWorkloadIdentity /> },
  { path: "workloadConditionalaccess", element: <WorkloadConditionalAccess /> }
];

const serviceAccountRouter = [
  { path: "", element: <ServiceAccount /> },
  { path: "addServiceAccount", element: <AddServiceAccount /> },
]



export { orgRouter, tenantRouter, settingsRouter, workloadIdentityRouter, serviceAccountRouter };